import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiRtk, parseErrorData, RTK_TAGS } from 'utils/service';
import { AppAsyncThunkConfig } from '../index';
import { NAMESPACE } from './helpers';

export const actionWeightSync = createAsyncThunk<
  void,
  void,
  AppAsyncThunkConfig
>(`${NAMESPACE}/actionWeightSync`, async (_, { dispatch}) => {
  try {
    await new Promise((resolve) => setTimeout(resolve, 3_000));

    dispatch(apiRtk.util.invalidateTags([
      { type: RTK_TAGS.DIET_DIARIES, id: 'weekly' },
      { type: RTK_TAGS.SESSIONS, id: 'sessions' }
    ]))
  } catch (e: any) {
    throw parseErrorData(e);
  }
});
